app.service('outletHashManager', function (pageConfig) {
	function getHuCode() {
		const hash = decodeURI(window.location.hash);

		if (!hash) {
			return;
		}

		const regexp = /(outlet-[a-z]+)\|hu-([0-9a-z]+)/g;
		const match = regexp.exec(hash);

		if (!match) {
			return null;
		}

		return match[2];
	}

	function getOutletCategoryId() {
		const hash = decodeURI(window.location.hash);

		if (!hash) {
			return;
		}

		const found = hash.match('outlet-[a-z]+');

		if (!found) {
			return null;
		}

		const linkName = found[0];
		const { outlet } = pageConfig.getData('productCard');

		return outlet[linkName].outletCategoryId;
	}

	return {
		getHuCode,
		getOutletCategoryId
	};
});
